import cartLineItem from '../components/cart-line-item';

function cartComponent(node) {
  let cartItems = node.querySelectorAll('[data-cart-item]');
  let shippingText = node.querySelector('[data-shipping-text]');

  const updateShippingText = () => {
    if (!shippingText) return;
    const showShippingText = shippingText.dataset.showShippingText;
    const freeShippingAmount = shippingText.dataset.freeShippingAmount;

    if (showShippingText === 'true') {
      shippingText.innerHTML = shippingText.innerHTML.replace(
        '{AMOUNT}',
        freeShippingAmount
      );
    }
  };

  const updateCartItems = () => {
    if (cartItems.length > 0) {
      cartItems.forEach((item) => {
        cartLineItem(item);
      });
    }
  };

  function initCartMain() {
    updateShippingText();
    updateCartItems();

    document.addEventListener('main-cart:update', () => {
      shippingText = node.querySelector('[data-shipping-text]');
      cartItems = node.querySelectorAll('[data-cart-item]');

      updateShippingText();
      updateCartItems();
    });
  }

  initCartMain();
}

document.addEventListener('DOMContentLoaded', () => {
  const cartMain = document.querySelector('[data-component="cartMain"]');
  if (!cartMain) return;
  cartComponent(cartMain);
});
